var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImgLeftPersonLarge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 217 347",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.725 35.945c7.299 13.606 6.432 48.119-3.002 50.55-3.762.97-11.777-1.405-19.934-6.322l5.119 36.223H13.676l10.407-48.511c-5.804-6.813-9.732-15.163-9.076-24.519 1.892-26.958 39.418-21.027 46.718-7.421z",
    fill: "#B28B67"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.759 73.954C17.965 57.073 7.155 45.565 8.806 38.02c1.101-5.03 4.034-8.158 8.8-9.384 2.466-9.972 10.416-14.214 23.852-12.725 20.153 2.234 32.454 10.603 27.142 29.02-4.883 0-10.778-1.766-18.929 1.26-2.587.96-4.436 3.937-5.55 8.931h-3.683c-3.575-5.927-7.1-8.105-10.575-6.534-3.475 1.571-4.265 5.387-2.37 11.448l-1.815 13.918h-3.919z",
    fill: "#2C0606"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.534 226.673L69.16 392.04l20.99 124.161h21.069L90.19 226.673H24.533z",
    fill: "#997659"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-.482 226.673C2.495 311.81 1.321 358.246.655 365.981c-.666 7.735-4.448 59.54-30.22 150.22h20.946c34.13-86.992 46.044-138.797 49.959-150.22 3.914-11.423 15.475-57.859 32.354-139.308H-.482z",
    fill: "#B28B67"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.707 226.673c12.146 55.645 33.155 144.467 63.025 266.468h32.243c2.382-125.222-7.749-207.639-25.293-266.468H19.707z",
    fill: "#552730"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-.441 226.673C2.75 310.68-5.52 393.443-31.137 494.449H3.265c37.43-84.556 64.257-166.91 82.592-267.776H-.441z",
    fill: "#5E333A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-55.881 212.962l26.593 1.523c-18.21 49.759-28.436 77.321-30.679 82.687l-.131.309c-.06.14-.113.258-.157.354-3.323 7.174 2.334 18.672 4.69 24.815-8.882 3.439-7.212-10.961-18.426-6.428-2.125.859-4.154 1.887-6.137 2.907l-1.078.554c-7.154 3.678-13.802 6.829-22.24.963-1.374-.956-2.759-4.352 1.133-6.74 9.698-5.951 23.776-16.521 25.79-20.14 2.748-4.934 9.629-31.869 20.642-80.804zM194.498 138l-.293.596-.581 1.196c-2.877 5.984-5.283 11.946-3.538 13.641 1.92 1.863 6.303-1.108 8.641 2.034 1.559 2.094-5.996 5.922-22.663 11.486l-30.549 31.21-17.248-16.751 42.905-26.616c6.885-9.151 13.765-16.337 20.641-21.559 2.131-1.028 5.913-1.779 2.685 4.763z",
    fill: "#B28B67"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.627 102.182l10.651-3.415c27.034 19.836 44.562 74.157 61.443 79.301 15.961 4.863 36.249-4.865 60.213-17.518l10.17 16.271c-19.431 28.159-65.333 56.094-86.829 46.85-34.367-14.778-51.33-82.429-55.649-121.489z",
    fill: "#2D4053"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-1.583 246.729l96.587-13.574c4.413-.621 2.682-6.908 1.59-10.05-12.606-36.264-47-72.43-54.462-125.523l-28.477-.474C-4.155 137.59-5.679 184.567-1.583 246.729z",
    fill: "#3C6083"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.888 95.81c37.053 82.164 51.971 138.283 44.755 168.357L-19.3 276.386c-1.555-21.048-.244-43.722 2.776-66.074-14.672 38.463-27.612 66.489-38.818 84.076l-20.805-1.139c1.618-83.112 30.953-148.408 88.004-195.89l11.031-1.55z",
    fill: "#2D4053"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M70.502 71.363L39.299 61.235l-7.797 24.023 12.18 3.953c10.507 3.41 21.788-2.343 25.198-12.849l1.622-4.999z",
    fill: "#C4C4C4"
  })));
}
export default SvgImgLeftPersonLarge;